import axios from 'axios'
const CancelToken = axios.CancelToken
// Check if vm is being destoyed or is destroyed
const isDestroyed = function (vm) {
  return vm._isBeingDestroyed || vm._isDestroyed
}
export default {
  data() {
    const source = CancelToken.source()
    return {
      sourceRequest: source,
      cancelToken: source.token,
    }
  },

  methods: {
    blockStateChange(callback) {
      if (!isDestroyed(this) && typeof callback === 'function') callback()
    },
    isCancel(request) {
      return isDestroyed(this) || axios.isCancel(request)
    },
  },

  beforeRouteLeave(to, from, next) {
    if (to.name !== from.name) {
      this.sourceRequest.cancel('canceled by user')
      // this.$store.commit('app/RESET_APP')
    }
    next()
  },
}
